// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"headerMenu__gradient-bg5__Pd8IT","headerMenu":"headerMenu__headerMenu__pAZZr"};